/**
 * 债券页面
 */
import React from "react"
import "./index.less"
import { StockHeader } from "../../shared/stock_header"
import { quotedata } from "../../shared/quotedata"
import { StockInfoTabs } from "../../shared/stock_info_tabs"
import { ChartTab } from "../../shared/chart_tab"
import { store } from "./store"
import { OpenInApp } from "../../shared/open_in_app"
import { GoTop } from "../../shared/go_top"
import { CommonFooter } from "../../shared/common_footer"
import { StockFixedFooter } from "../../shared/stock_fixed_footer"
import { AdvertiseTop } from "../../shared/advertise_top"
import { BondBasicInfo } from "./basic_info"
import { getPageType, getBondSubType, PageBondType, getStockSubType, PageType, StockSubType, getStockErrorTradeStatus } from "../../shared/pagetype"
import { Observer } from "mobx-react-lite"
import { getMarketSource } from "../../../modules/quote/web"
import { BondNotice } from "./bond_notice"
import { StockPrice } from "./stock_price"
import { BondExtraPanKou } from "./bond_extra_pankou"

export function Page_Bond(props: { quotedata: quotedata }) {
  let pagetype = getPageType()
  let stocksubtype = getStockSubType()
  let bondsubtype = getBondSubType()
  let _market = getMarketSource(props.quotedata.quotecode)
  let trade_status = getStockErrorTradeStatus() 

  let infoTabs = ["股吧", "资讯", "公告"]
  if (bondsubtype == PageBondType.深证现券 || bondsubtype == PageBondType.北证债券) {
    infoTabs = ["报价", "股吧", "资讯", "公告"]
  } else if(bondsubtype == PageBondType.上证可转债 || bondsubtype == PageBondType.深证可转债){
    infoTabs = ["股吧", "资讯", "公告", "必读"]
  }

  return (
    <>
      <AdvertiseTop />
      <div className="stock-detail">
        <WrapStockHeader quotedata={props.quotedata} pagetype={pagetype}/>
        <BondBasicInfo quotedata={props.quotedata} bondsubtype={bondsubtype} trade_status={trade_status}/>
        <WrapStockPrice quotedata={props.quotedata} bondsubtype={bondsubtype} />
        {(bondsubtype == PageBondType.上证质押式回购 || bondsubtype == PageBondType.深证质押式回购) && <WrapBondExtraPanKou pagetype={pagetype}/>}
        {(bondsubtype == PageBondType.深证现券 || bondsubtype == PageBondType.北证债券) && <BondNotice />}
        <WrapCharts quotedata={props.quotedata} pagetype={pagetype} stocksubtype={stocksubtype} bondsubtype={bondsubtype} />
        <StockInfoTabs showTabs={infoTabs} quotedata={props.quotedata} pagetype={pagetype} _market={_market} stocksubtype={stocksubtype} bondsubtype={bondsubtype} />
      </div>
      <OpenInApp quotedata={props.quotedata} type={"page"} />
      <GoTop />
      <CommonFooter quotedata={props.quotedata} hide_fix_bottom={false} />
      <StockFixedFooter quotedata={props.quotedata} pagetype={pagetype} />
    </>
  )
}

function WrapStockHeader(props: { quotedata: quotedata ,pagetype: PageType}) {
  return <Observer>{() => <StockHeader quotedata={props.quotedata} detail_data={store.StockDetail} pagetype={props.pagetype}/>}</Observer>
}

function WrapCharts(props: { quotedata: quotedata; pagetype: PageType; stocksubtype: StockSubType; bondsubtype: PageBondType }) {
  return <Observer>{() => <>{store.StockDetail && <ChartTab quotedata={props.quotedata} pagetype={props.pagetype} stocksubtype={props.stocksubtype} bondsubtype={props.bondsubtype} />}</>}</Observer>
}

function WrapStockPrice(props: { quotedata: quotedata ,bondsubtype: PageBondType}) {
  return <Observer>{() => <StockPrice quotedata={props.quotedata} bondsubtype={props.bondsubtype} data={store.StockDetail} />}</Observer>
}

function WrapBondExtraPanKou(props: { pagetype: PageType}) {
  return <Observer>{() => <>{store.StockDetail && <BondExtraPanKou pagetype={props.pagetype} chartType={store.chartType} detail_data={store.StockDetail} chart_mouse_move_data={store.chart_mouse_move_data}/>}</>}</Observer>
}